import React, { useEffect, useState } from 'react'
import { DilContext, useContext } from '../ContextDil';

import {
    
    PortfolioItem,
  
    PortfolioItemImage,
    PortfolioItemImageContainer,
 
    PortfolioTitle,
  
    Title,
    Price,
   
  } from "./styles";
  
  

const ProductItems  = ({ id,item,openModal }) => {
  
  
    const [resim, setResim] = useState("");
    const [xdata, setData] = useState([]);

    const url1 = "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/product_options/" + id + "/" +item.URUN_KOD;
    const url2 = "https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/product_pictures/" + id + "/" + item.URUN_KOD;
    const {lang} =useContext(DilContext);

  useEffect(() => {
    try {

      fetch(url1)
        .then((datax) => {
          datax.text().then(
            text => setData(text.replaceAll("'", '"')))
        }).catch(err => {
          //console.log(err);
          setData([]);
        });

    } catch (e) {
       setData([]);
    }
    try {

      fetch(url2)
        .then((data) => {
          data.text().then(
            text => setResim(text))
        });
    } catch (e) {
      setResim("");
    }
  }, [url2, url1]);

  return (
    <>
      <PortfolioItem key={item.id}
        onClick={() => openModal(true, item, resim, xdata)}
      >
        <PortfolioItemImageContainer>
          {resim ? (
            <PortfolioItemImage src={resim} alt="" />
          ) : null}
        </PortfolioItemImageContainer>
        <PortfolioTitle>
          {(lang === "en") ?
            <Title>

              {item.URUN_ADI_ING}


            </Title>
            :
            <Title>

              {item.URUN_ADI}


            </Title>
          }
          <Price>{item.FIYATI} TL</Price>
        </PortfolioTitle>

      </PortfolioItem>

    </>
  )


}

export default ProductItems
